import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useTeamScope } from "../contexts/useTeamScope";

interface CaptainRouteProps {
  children: ReactNode;
}

/**
 * A page that only a captain may open.
 *
 * Hiding the entry in the navigation is not enough - the address bar still works, and a
 * bookmark from the time somebody was captain still works too. The server refuses either
 * way; this only spares the player a page full of errors.
 *
 * While the role is still being fetched nothing is decided. Sending somebody away during
 * loading would throw the captain out of their own page on every reload.
 */
const CaptainRoute = ({ children }: CaptainRouteProps) => {
  const { isCaptain, loading } = useTeamScope();

  if (loading) return <div className="page-feedback">Berechtigung wird geprüft...</div>;

  if (!isCaptain) return <Navigate to="/team" replace />;

  return <>{children}</>;
};

export default CaptainRoute;
